import { render, staticRenderFns } from "./TeacherPhotoStyled.vue?vue&type=template&id=0a229c84&"
import script from "./TeacherPhotoStyled.vue?vue&type=script&lang=js&"
export * from "./TeacherPhotoStyled.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPhotoStyled.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports